import { Point } from 'ol/geom';
import { Fill, RegularShape, Stroke, Style } from 'ol/style';
import { COLOR } from '@tmapy/config';
import { LINE_WIDTH, OUTLINE_WIDTH, ARROW_SIZE } from '../../style';
const getArrowStyles = function (start, end, style) {
    const dx = end[0] - start[0];
    const dy = end[1] - start[1];
    const mx = (end[0] + start[0]) / 2;
    const my = (end[1] + start[1]) / 2;
    const rotation = -Math.atan2(dy, dx);
    return [
        new Style({
            geometry: new Point([mx, my]),
            image: new RegularShape({
                stroke: new Stroke({
                    color: COLOR.OUTLINE,
                    width: LINE_WIDTH + 2 * OUTLINE_WIDTH,
                }),
                points: 3,
                radius: ARROW_SIZE + style.width,
                rotation,
                angle: -Math.PI / 2,
            }),
        }),
        new Style({
            geometry: new Point([mx, my]),
            image: new RegularShape({
                fill: new Fill({
                    color: style.color,
                }),
                stroke: new Stroke({
                    color: style.color,
                    width: LINE_WIDTH,
                }),
                points: 3,
                radius: ARROW_SIZE + style.width,
                rotation,
                angle: -Math.PI / 2,
            }),
        }),
    ];
};
const getArrowOnLine = (coordinates, style) => {
    let styles = [];
    for (let i = 0; i < coordinates.length - 1; i++) {
        styles = styles.concat(getArrowStyles(coordinates[i], coordinates[i + 1], style));
    }
    return styles;
};
/**
 * const arrowsStyles = getArrowsStyles(feature, {
 *    color: mapNotesSymbols.getStateColor(featureStyle.color),
 *    width: featureStyle.lineWidth,
 * });
 * @param feature
 * @param style
 * @returns
 */
export const getArrowsStyles = function (feature, style) {
    const styles = [];
    const geometry = feature.getGeometry();
    const geomType = geometry.getType();
    switch (geomType) {
        case 'MultiLineString': {
            return geometry
                .getCoordinates()
                .reduce((styles, coordinates) => styles.concat(getArrowOnLine(coordinates, style)), styles);
        }
        case 'LineString': {
            const coordinates = geometry.getCoordinates();
            return getArrowOnLine(coordinates, style);
        }
    }
    return styles;
};
//# sourceMappingURL=arrow.js.map